import { z } from 'zod'

// --- Branch Office (API response) ---
export interface BranchOffice {
  id: number
  address: string
  commune: string
  id_company: number
}

// --- Form schema ---
export const branchFormSchema = z.object({
  commune: z.string().min(1, 'Comuna es requerida'),
  address: z.string().min(1, 'Dirección es requerida'),
})

export type BranchFormData = z.infer<typeof branchFormSchema>
